/**
 * Local Business API Service
 * 
 * Handles Google Business Profile data.
 * Migrated from seo-engine-webtools-customer-module
 */

import customerApi, { USE_MOCK_DATA } from './customerApi';
import { LocalBusinessResponse } from '@/types/customer';

// Mock data for development
const localBusinessMockData: LocalBusinessResponse = {
  siteId: 1,
  propertyId: 101,
  overview: {
    averageRating: 4.6,
    totalReviews: 342,
    responseRate: 0.89,
    avgResponseTimeHours: 4.2,
  },
  metrics: {
    period: 'Last 28 days',
    searchViews: 15200,
    mapViews: 8900,
    websiteClicks: 2340,
    directionRequests: 1560,
    phoneCallClicks: 890,
  },
  recentReviews: [
    {
      id: 1,
      propertyId: 101,
      reviewId: 'rev-001',
      reviewerName: 'John D.',
      rating: 5,
      comment: 'Excellent service! Highly recommended.',
      reviewReply: 'Thank you for your kind words!',
      reviewReplyTime: '2026-01-20T14:30:00Z',
      createTime: '2026-01-19T10:00:00Z',
      updateTime: '2026-01-19T10:00:00Z',
      createdAt: '2026-01-19T10:00:00Z',
    },
    {
      id: 2,
      propertyId: 101,
      reviewId: 'rev-002',
      reviewerName: 'Sarah M.',
      rating: 4,
      comment: 'Good experience overall. Would visit again.',
      createTime: '2026-01-18T15:30:00Z',
      updateTime: '2026-01-18T15:30:00Z',
      createdAt: '2026-01-18T15:30:00Z',
    },
    {
      id: 3,
      propertyId: 101,
      reviewId: 'rev-003',
      reviewerName: 'Mike R.',
      rating: 5,
      comment: 'Best in the area! Professional staff.',
      reviewReply: 'We appreciate your feedback!',
      reviewReplyTime: '2026-01-17T09:00:00Z',
      createTime: '2026-01-16T11:00:00Z',
      updateTime: '2026-01-16T11:00:00Z',
      createdAt: '2026-01-16T11:00:00Z',
    },
  ],
  pendingQAs: [
    {
      id: 1,
      propertyId: 101,
      questionId: 'qa-001',
      question: 'What are your operating hours on weekends?',
      questionTime: '2026-01-21T08:00:00Z',
      questionerName: 'Anonymous User',
      upvoteCount: 5,
      createdAt: '2026-01-21T08:00:00Z',
    },
    {
      id: 2,
      propertyId: 101,
      questionId: 'qa-002',
      question: 'Do you offer parking?',
      questionTime: '2026-01-20T12:30:00Z',
      questionerName: 'Local Guide',
      answer: 'Yes, we have free parking available for customers.',
      answerTime: '2026-01-20T14:00:00Z',
      answererName: 'Business Owner',
      upvoteCount: 12,
      createdAt: '2026-01-20T12:30:00Z',
    },
  ],
};

/**
 * Get local business data for a site
 */
export async function getLocalBusiness(siteId: number): Promise<LocalBusinessResponse> {
  if (USE_MOCK_DATA) {
    await new Promise((resolve) => setTimeout(resolve, 500));
    return localBusinessMockData;
  }

  const response = await customerApi.get<{ success: boolean; data: LocalBusinessResponse }>(
    `/webtools/sites/${siteId}/local-business`
  );
  return response.data.data;
}

export default {
  getLocalBusiness,
};
